/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScannerListResponseDetails extends models.ScannerRuleBase {
    getFixupPrototypeFunction() { return ScannerListResponseDetails.fixupPrototype; }

    static newInstance(model: Partial<ScannerListResponseDetails>): ScannerListResponseDetails {
        let obj = Object.assign(new ScannerListResponseDetails(), model);
        ScannerListResponseDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScannerListResponseDetails>): ScannerListResponseDetails {
        if (!model) return null;
        return ScannerListResponseDetails.newInstance(<ScannerListResponseDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScannerListResponseDetails) {
        if (!obj) return;

        models.ScannerListResponseDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScannerListResponseDetails): boolean {
        if (models.ScannerRuleBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScannerListResponseDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Boolean to check whether the input has been override in this github account.
     */
    is_rule_override: boolean;

    /**
     * Boolean to check whether the rule is available in this github account.
     */
    is_rule_available: boolean;

    /**
     * inputs with which the rules are getting scanned.
     */
    values: Array<string>;

    /**
     * resource types which are scanned against the resource configurations.
     */
    applicable_service: string;

}
